import React from "react";
import "./FourTileMetrics.css";
import TileMetric, { TileMetricProps } from "./TileMetric.tsx";

interface FourTileMetricsProps {
  metrics: TileMetricProps[];
}

const FourTileMetrics: React.FC<FourTileMetricsProps> = ({ metrics }) => {
  return (
    <div className="four-tile-metrics-container">
      {metrics.map((metric, index) => (
        <TileMetric key={index} {...metric} />
      ))}
    </div>
  );
};

export default FourTileMetrics;